// extracted by mini-css-extract-plugin
export default {"desktop":"AddNewWorkbookTaskModal_desktop__8iv6X","itemTitle":"AddNewWorkbookTaskModal_itemTitle__Z-mil"};